<script>
  import Icon from "@iconify/svelte";
  import closeIcon from "@iconify/icons-mdi/close";

  export let alerts = [];
  export let onDismiss = () => {};
</script>

{#if alerts.length > 0}
  <div class="space-y-2">
    {#each alerts as alert (alert.id)}
      <div class="rounded-lg border border-rose-400/30 bg-rose-400/10 px-4 py-3 text-sm text-rose-200">
        <div class="flex items-start justify-between gap-3">
          <span class="break-words">{alert.message}</span>
          <button
            type="button"
            class="mt-0.5 rounded-md p-1 text-rose-200/70 hover:text-rose-100"
            onclick={() => onDismiss(alert.id)}
            aria-label="Dismiss alert"
          >
            <Icon icon={closeIcon} width="14" height="14" />
          </button>
        </div>
      </div>
    {/each}
  </div>
{/if}
